<template>
  <Body class="page-video" />

  <section class="section page-header">
    <div class="wrap">
      <div class="text">
        <h1 class="title">
          {{ $t('비디오뮤직') }}
        </h1>
        <div class="desc" v-html="$t('어머니사랑의언어가부른평화의이야기br영상으로만나보세요')"></div>
      </div>
    </div>
  </section>


  <section class="toggletab">
    <div class="wrap">
      <div class="slide-toggles">
        <div class="btn-toggles"></div>
        <div class="items">
          <!--TODO  선택된 탭에 current 붙여주세요. 후기와 동일하게 스크립트 적용해주세요 -->
          <div class="slide-item" :class="{ current: category === '' }" @click="changeCategory('')">{{ $t('전체') }}</div>
          <div class="slide-item" :class="{ current: category === '비디오' }" @click="changeCategory('비디오')">{{ $t('비디오') }}</div>
          <div class="slide-item" :class="{ current: category === '뮤직' }" @click="changeCategory('뮤직')">{{ $t('뮤직') }}</div>
        </div>
      </div>
    </div>
  </section>


  <!-- ********** Lists ********** -->
  <section class="section">
    <div class="wrap">
      <ul class="lists list-video">
        <li class="list-item" v-for="(video, index) in videos?.videos" :key="index">
          <NuxtLink :to="$localePath(`/video/${video.id}`)" class="list-link">
            <div class="thum">
              <div class="playtime">{{ video.playTime }}</div>
              <div class="thum-img" :style="{ backgroundImage: `url(${video.thumbnailUrl})` }"></div>
            </div>
            <div class="info">
              <div class="post-title">{{ video.title }}</div>
            </div>
          </NuxtLink>
        </li>
      </ul>
    </div>

    <!-- pagination -->
     <Paging 
      v-if="videos?.total && videos?.total >= 1" 
      :page-size="pageSize" 
      :total-count="videos?.total" 
      :page="page"
      @update:page="changePage"
      />

    <!-- nodata -->
    <div v-if="videos?.total === 0" class="no-data wrap">
      {{ keyword !== '' ? $t('검색결과가없습니다') : $t('등록된글이없어요') }}
    </div>

    <!-- search -->
     <!-- searchKeyword != '' -> 표시 (total >0 이든, 아니든 표시)
        searchKeyword == '' 이면, total > 0 이면 표시
        searchKeyword == '' 이면, total === 0 이면 표시하지 않음
     -->
    <div v-if="(keyword !== '' || (videos?.total && videos?.total > 0))" class="list-search wrap">
      <div class="input">
        <input v-model="keywordValue" class="input-field" type="text" :placeholder="$t('search')"
          @keyup.enter="changeKeyword">
        <button class="input-right-addon" type="button" name="button" @click="changeKeyword">
          <span class="blind">Submit</span>
          <i class="ico ico-search" />
        </button>
      </div>
    </div>
  </section>

</template>

<script lang="ts" setup>
import type { VideoModel } from '~~/shared/types/models';

const { locale } = useI18n()
const { $t } = useNuxtApp()

useHead({
  title: `${$t('비디오뮤직')} - ${$t('어머니사랑과평화의날캠페인')}` ,
  link: [
    { rel: 'stylesheet', href: `/css/video.css?${useBuildTime()}` },
  ],
})
const route = useRoute();

// 카테고리
const category = computed(() => route.query.category ?? '')

// 페이징
const page = computed(() => Number(route.query.page ?? '1'))
const pageSize = 6;
async function changePage(page: number) {
  await navigateTo({ query: { ...route.query, ...{ page } } })
}

// 검색
const keyword = computed(() => route.query.keyword ?? '')
const keywordValue = ref<string>((route.query.keyword as string) ?? '')
async function changeKeyword() {
  await navigateTo({ query: { ...route.query, ...{ keyword: keywordValue.value }, ...{ page: 1 } } })
}

// 카테고리
async function changeCategory(category: string) {
  await navigateTo({ query: { ...route.query, ...{ category } } })
}

const { data: videos } = await useFetch<{ videos: VideoModel[], total: number }>('/api/videos', {
  method: 'GET',
  query: { languageGbSn: locale.value, category, page, pageSize, keyword },
});
</script>
